import CommonStore from "../stores/CommonStore";
import AuthStore from "../stores/AuthStore";
import { UserStore } from "../stores/UserStore";
import PageContentStore from "../stores/PageContentStore";

export const commonStore = CommonStore.create({});
export const authStore = AuthStore.create({}, { commonStore });
export const userStore = UserStore.create({}, { commonStore });
export const pageContentStore = PageContentStore.create({}, { commonStore });
